module.exports = __webpack_public_path__ + "img/mariajoseurrutia.0b59218a.jpg";